import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ListStatus } from "@/constants/default";
import { FormProvider, useForm } from "react-hook-form";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useEditTransactionTypeMutation, useGetTransactionTypeQuery } from "@/services/transactiontype.service";
import Information, { TransactionTypeFieldForm } from "./_information";

export default function EditTransactionType() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const listStatus = ListStatus();
    const [editTransactionType, { isSuccess }] = useEditTransactionTypeMutation()
    const {data: transactionType} = useGetTransactionTypeQuery(location.state?.id || "", {refetchOnMountOrArgChange: true})
    const methods = useForm<TransactionTypeFieldForm>()
    const {handleSubmit, setValue} = methods

    const onSubmit = handleSubmit(async (data) => {
        if(transactionType) {
            editTransactionType({...data, id: transactionType.id})
        }
    })

    useEffect(() => {
        if(transactionType) {
            setValue("name", transactionType.name)
            setValue("status", _.find(listStatus, item => item.value === transactionType.status)?.value || listStatus[0].value)
        }
    }, [transactionType])

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-sm rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("transaction_type.edit_transaction_type")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                   
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
